import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const useExperiences = () => {
  const [experiences, setExperiences] = useState([]);
  useEffect(() => {
    fetch(`${API}/api/experiences`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => setExperiences(Array.isArray(data) ? data : []))
      .catch(() => setExperiences([]));
  }, []);
  return experiences;
};
